var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { combineReducers } from "redux";
import currentUserDetailsReducersMapObject from "@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer";
import getWorkspaceReducersMapObject from "@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks";
import UserAccessReducersMapObject from "@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer";
import { rootReducer } from "@ane/exp-data/lib/redux/api";
import "../views/common/ducks/index.js";
import "../views/Create/ducks/index.js";
import "../views/View/ducks/index.js";
import "../views/List/ducks/index.js";
import { capacitySearchContextReducer } from "../views/capacity/CapacitySearchContext.js";
import routeUpdateReducer from "@ane/core/lib/services/syncUrlAndStore/RouteUpdateReducer";
import { authoringApi } from "@ane/exp-data/lib/redux/rtkquery";
import { reducer } from "../views/common/ducks/ducks.js";
import { reducer as reducer$1 } from "../views/Create/ducks/ducks.js";
import { reducer as reducer$2 } from "../views/View/ducks/ducks.js";
import { reducer as reducer$3 } from "../views/List/ducks/ducks.js";
const moduleReducer = __spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, currentUserDetailsReducersMapObject), getWorkspaceReducersMapObject), UserAccessReducersMapObject), rootReducer), routeUpdateReducer), {
  [authoringApi.reducerPath]: authoringApi.reducer,
  isolation_group_app_module: combineReducers({
    common: reducer,
    create: reducer$1,
    view: reducer$2,
    list: reducer$3,
    capacity: capacitySearchContextReducer
  })
});
export {
  moduleReducer as default,
  moduleReducer
};
//# sourceMappingURL=reducers.js.map
